import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {CommonSectionsModule} from '../views/common/common-sections.module';
import {EmailVerificationFormComponent} from '../email-verification-form/email-verification-form.component';
import {EmailVerificationModalComponent} from '../email-verification-modal/email-verification-modal.component';
import {MatButtonModule, MatFormFieldModule, MatInputModule, MatProgressSpinnerModule} from '@angular/material';
import {InvestmentApplicationEmailVerificationComponent, LoanApplicationEmailVerificationComponent} from './email-verification.component';
import {ButtonModule} from '../views/common/button/button.module';

const materialModules: any[] = [MatProgressSpinnerModule, MatFormFieldModule, MatInputModule, MatButtonModule];

@NgModule({
    exports: [InvestmentApplicationEmailVerificationComponent, LoanApplicationEmailVerificationComponent, EmailVerificationModalComponent],
    declarations: [InvestmentApplicationEmailVerificationComponent, LoanApplicationEmailVerificationComponent,
        EmailVerificationFormComponent, EmailVerificationModalComponent],
    imports: [CommonSectionsModule, ButtonModule, ReactiveFormsModule, ...materialModules]
})
export class EmailVerificationModule {
}